export const CALENDAR_VIEWS = ['agenda', 'day', 'week', 'month', 'year'];
const key = userId => `timely-calendar-view:${userId}`;

export function readCalendarView(userId) {
  if (!userId) return '';
  try {
    const value = localStorage.getItem(key(userId));
    return CALENDAR_VIEWS.includes(value) ? value : '';
  } catch { return ''; }
}

export function saveCalendarView(userId, view) {
  if (!userId || !CALENDAR_VIEWS.includes(view)) return false;
  try { localStorage.setItem(key(userId), view); return true; } catch { return false; }
}
